const statusValue = value => value?.databaseValue ?? value ?? 'UNDEFINED';

export const orderItemKey = item => `${item.productId}:${statusValue(item.productStatus)}`;
export const orderItemReference = item => ({ productId: item.productId, productStatus: statusValue(item.productStatus) });
